export function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
    }
  }
  return null;
}

export function canAccessViz() {
  if (typeof window === 'undefined') return false;
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1'
  );
}

export function getCSSVariable(variableName) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  if (!value) {
    const defaults = {
      '--my-color-blue': 'hsl(210, 85%, 65%)',
      '--my-color-green': 'hsl(150, 85%, 65%)',
      '--my-color-red': 'hsl(0, 85%, 65%)',
      '--my-color-white': 'hsl(210, 60%, 92%)',
      '--my-color-yellow': 'hsl(60, 98%, 63%)',
      '--my-color-background-gray': '#dedede',
      '--my-color-dark-gray': '#393939',
      '--my-color-light-gray': '#7d7d7d',
      '--my-color-highlight-gray': '#c8c8c8',
    };
    return defaults[variableName] || value;
  }
  return value;
}

export function createGradientSpectrum({
  svg,
  colors,
  gradientAreaLeft,
  gradientAreaTop,
  gradientAreaWidth,
  gradientAreaHeight,
}) {
  const blue = colors.blue || 'hsl(210, 85%, 65%)';
  const green = colors.green || 'hsl(150, 85%, 65%)';
  const red = colors.red || 'hsl(0, 85%, 65%)';
  const white = colors.white || 'hsl(210, 60%, 92%)';
  const backgroundGray = colors.backgroundGray || '#dedede';

  const defs = svg.append('defs');

  const gradientGroup = svg.append('g').attr('class', 'gradient-spectrum');

  const topLeftGradient = defs
    .append('radialGradient')
    .attr('id', 'topLeftGradient')
    .attr('gradientUnits', 'objectBoundingBox')
    .attr('cx', '0')
    .attr('cy', '0')
    .attr('r', '2.5');
  topLeftGradient
    .append('stop')
    .attr('offset', '0%')
    .attr('stop-color', blue)
    .attr('stop-opacity', '1.0');
  topLeftGradient
    .append('stop')
    .attr('offset', '92%')
    .attr('stop-color', blue)
    .attr('stop-opacity', '0');

  const topRightGradient = defs
    .append('radialGradient')
    .attr('id', 'topRightGradient')
    .attr('gradientUnits', 'objectBoundingBox')
    .attr('cx', '1')
    .attr('cy', '0')
    .attr('r', '1.3');
  topRightGradient
    .append('stop')
    .attr('offset', '0%')
    .attr('stop-color', red)
    .attr('stop-opacity', '1.0');
  topRightGradient
    .append('stop')
    .attr('offset', '60%')
    .attr('stop-color', red)
    .attr('stop-opacity', '0');

  const bottomLeftGradient = defs
    .append('radialGradient')
    .attr('id', 'bottomLeftGradient')
    .attr('gradientUnits', 'objectBoundingBox')
    .attr('cx', '0')
    .attr('cy', '1')
    .attr('r', '1.5');
  bottomLeftGradient
    .append('stop')
    .attr('offset', '0%')
    .attr('stop-color', green)
    .attr('stop-opacity', '1.0');
  bottomLeftGradient
    .append('stop')
    .attr('offset', '70%')
    .attr('stop-color', green)
    .attr('stop-opacity', '0');

  const bottomRightGradient = defs
    .append('radialGradient')
    .attr('id', 'bottomRightGradient')
    .attr('gradientUnits', 'objectBoundingBox')
    .attr('cx', '1')
    .attr('cy', '1')
    .attr('r', '1.5');
  bottomRightGradient
    .append('stop')
    .attr('offset', '0%')
    .attr('stop-color', white)
    .attr('stop-opacity', '1.0');
  bottomRightGradient
    .append('stop')
    .attr('offset', '70%')
    .attr('stop-color', white)
    .attr('stop-opacity', '0');

  gradientGroup
    .append('rect')
    .attr('x', gradientAreaLeft)
    .attr('y', gradientAreaTop)
    .attr('width', gradientAreaWidth)
    .attr('height', gradientAreaHeight)
    .attr('fill', backgroundGray);

  gradientGroup
    .append('rect')
    .attr('x', gradientAreaLeft)
    .attr('y', gradientAreaTop)
    .attr('width', gradientAreaWidth)
    .attr('height', gradientAreaHeight)
    .attr('fill', 'url(#topLeftGradient)')
    .attr('mix-blend-mode', 'screen');

  gradientGroup
    .append('rect')
    .attr('x', gradientAreaLeft)
    .attr('y', gradientAreaTop)
    .attr('width', gradientAreaWidth)
    .attr('height', gradientAreaHeight)
    .attr('fill', 'url(#topRightGradient)')
    .attr('mix-blend-mode', 'screen');

  gradientGroup
    .append('rect')
    .attr('x', gradientAreaLeft)
    .attr('y', gradientAreaTop)
    .attr('width', gradientAreaWidth)
    .attr('height', gradientAreaHeight)
    .attr('fill', 'url(#bottomLeftGradient)')
    .attr('mix-blend-mode', 'screen');

  gradientGroup
    .append('rect')
    .attr('x', gradientAreaLeft)
    .attr('y', gradientAreaTop)
    .attr('width', gradientAreaWidth)
    .attr('height', gradientAreaHeight)
    .attr('fill', 'url(#bottomRightGradient)')
    .attr('mix-blend-mode', 'screen');

  return gradientGroup;
}
